class ContentTabs extends HTMLElement {
  constructor() {
    super();

    this.tabButtons = this.querySelectorAll(".tab-button");
    this.settingTabsContent = this.querySelectorAll(".tab-content");

    this.tabButtons.forEach((tabsButton, index) => {
      tabsButton.addEventListener("click", () => {
        this.tabButtons.forEach((tabButton) => {
          tabButton.classList.remove("button-active");
        });
        tabsButton.classList.add("button-active");
        let tabID = this.tabButtons[index].id;
        this.settingTabsContent.forEach((settingsContent) => {
          settingsContent.classList.remove("tab-active");
        });
        document.getElementById(tabID + "-content").classList.add("tab-active");
      });
    });
  }
}

customElements.define("content-tabs", ContentTabs);